// extracted by mini-css-extract-plugin
export default {"valuesList":"values_list-module___valuesList___b0c5a8e9"};